/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect, useState } from "react";
import { useConfigContext } from "../../../contexts/ConfigContext";
import { useSnackbar} from "react-simple-snackbar";

import BasePage from "../../BasePage/BasePage";
import Slogan from "./Slogan/Slogan";
import Careers from "./Careers/Careers";

import { mapToLanguages, getTranslation } from "../../../services/translation";
import { useTranslation } from "react-i18next";

const EVENT_ID = process.env.REACT_APP_EVENT_ID || "fialinks-2022";

const IndexPage = () => {
    const [openSnack] = useSnackbar();
    const { t } = useTranslation();

    const [eventInfo, setEventInfo] = useState({});
    const { startLoading, stopLoading, lang } = useConfigContext();

    useEffect(() => {
        const fetchInfo = async () => {
            try {
                startLoading("fetch-event-info");

                const { data } = await axios.get(`/info/event/${EVENT_ID}`);
                setEventInfo(mapToLanguages(data, "summary", "slogan"));
            } catch (error) {
                openSnack(t("snack_error_fetch"));
            } finally {
                stopLoading("fetch-event-info");
            }
        }
        fetchInfo();
    }, []);

    return (
        <BasePage className="!p-0 md:flex-col child:p-8 child:flex child:justify-center child:w-full">
            <Slogan
                title={ getTranslation(eventInfo, "slogan", lang) }
                description={ getTranslation(eventInfo, "summary", lang) }
            />

            <Careers/>
        </BasePage>
    );
}

export default IndexPage;